import React, { Component } from 'react'
import { FormItem, FormGroup, Type } from "../core/FormScheme";
import FormItemDragComponent from "./FormItemDragComponent";
import { DragSource, DropTarget } from 'react-dnd'

export class FormGroupDragComponentInner extends Component<{
    items: (FormItem | FormGroup)[]
    formKey: string
    [key: string]: any,
}> {
    render() {
        const formItems = this.props.items.map((item: FormItem | FormGroup, index) => {
            let formKey = this.props.formKey + "." + item.key
            if ((item as any).class) {
                return (
                    <FormItemDragComponent key={item.key} class={(item as FormItem).class} {...this.props} formKey={formKey}
                        index={index} name={item.name} item={item} {...(item as FormItem).props}></FormItemDragComponent>
                )
            } else {
                return (
                    <FormGroupDragComponent key={item.key} items={(item as FormGroup).children} formKey={formKey}
                        index={index} name={item.name} item={item}></FormGroupDragComponent>
                );
            }
        })
        return (
            <div style={style}>
                {formItems}
            </div>
        )
    }
}

const style: React.CSSProperties = {
    border: '1px dashed gray',
    padding: '0.5rem 1rem',
    marginBottom: '.5rem',
    backgroundColor: 'white',
    cursor: 'move',
    width: '100%'
}

const WfComponentTarget = {
    drop(props, monitor) {
        const item = monitor.getItem();
        // console.log("item", item)
        if (item && item.index != undefined) {
            const dragIndex = item.index
            const hoverIndex = props.index;

            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {
                return;
            }

            // Time to actually perform the action
            props.moveField(dragIndex, hoverIndex);

            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            monitor.getItem().index = hoverIndex;
        } else {
            const hoverIndex = props.index;
            props.addField(item, hoverIndex)
        }
    },
};
const WfComponentDropConnect = (connect, monitor, props) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
})


const WfComponentSource = {
    beginDrag(props) {
        // Return the data describing the dragged item
        const item = {
            id: props.formKey,
            index: props.index,
            item: props.item
        }
        return item
    },

    endDrag(props, monitor, component) {
        if (!monitor.didDrop()) {
            return
        }

        // When dropped on a compatible target, do something
        const item = monitor.getItem()
        const dropResult = monitor.getDropResult()
        //   CardActions.moveCardToList(item.id, dropResult.listId)
    },
}

/**
 * Specifies which props to inject into your component.
 */
function collect(connect, monitor) {
    return {
        // Call this function inside render()
        // to let React DnD handle the drag events:
        connectDragSource: connect.dragSource(),
        // You can ask the monitor about the current drag state:
        isDragging: monitor.isDragging(),
    }
}

const FormGroupDragComponent = DropTarget(["field", "component"], WfComponentTarget, WfComponentDropConnect)(DragSource("field", WfComponentSource, collect)(FormGroupDragComponentInner))
export default FormGroupDragComponent